import type { UpsellArticle } from "@/types";

export const isLocked = (article: UpsellArticle): boolean => article.upsell !== "unlocked";
export const isUnlocked = (article: UpsellArticle): boolean => article.upsell === "unlocked";
export const isUnlockable = (article: UpsellArticle): boolean => article.upsell === "unlockable";
export const isAllUnlocked = (articles: UpsellArticle[]): boolean => articles.every(isUnlocked);
